const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/the-game-awards.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { getGameAwardsData } from "@/queries/game-awards";
import i18n from "@/lib/i18n";
export const Route = createFileRoute("/{-$locale}/the-game-awards")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    context
  }) => {
    const {
      queryClient
    } = context;
    await queryClient.prefetchQuery({
      queryKey: ["game-awards"],
      queryFn: () => getGameAwardsData().catch(() => [])
    });
  },
  head: () => {
    const title = i18n.t("misc.gameAwards.meta.title");
    const description = i18n.t("misc.gameAwards.meta.description");
    const image = "https://api.egdata.app/game-awards/og";
    return {
      meta: [{
        title
      }, {
        name: "description",
        content: description
      }, {
        property: "og:title",
        content: title
      }, {
        property: "og:description",
        content: description
      }, {
        property: "og:image",
        content: image
      }, {
        property: "twitter:title",
        content: title
      }, {
        property: "twitter:description",
        content: description
      }, {
        property: "twitter:image",
        content: image
      }, {
        name: "twitter:card",
        content: "summary_large_image"
      }]
    };
  }
});